import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Card } from "flowbite-react";
import { getCampaignById } from "../../api/campaigns";
import { getCampaignPerformance } from "../../api/performance";

const CampaignView = () => {
  const { id } = useParams();
  const [campaign, setCampaign] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchCampaign = async () => {
      try {
        const _campaign = await getCampaignById(id);
        const _performance = await getCampaignPerformance(id);

        setCampaign(_campaign);
        setData(_performance);
      } catch (error) {
        console.error(error);
        toast.error('Error fetching campaign');
      }
    }

    fetchCampaign();
  }, [id]);

  if (!id || !campaign || !data) return null;

  return (
    <>
      <div className="flex gap-2 justify-between items-center border-b border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800 sm:flex">
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">{campaign?.name}</h1>
      </div>
      <div className="p-4 flex flex-col gap-4">
        <Card>
          <div className="flex flex-col gap-4">
            {campaign?.flowType && <p><span className="font-bold">Flow type:</span> {campaign.flowType}</p>}
            {campaign?.brandId?.name && <p><span className="font-bold">Brand:</span> {campaign.brandId.name}</p>}
            {campaign?.language && <p><span className="font-bold">Language:</span> {campaign.language}</p>}
            {campaign?.startDate && <p><span className="font-bold">Start date:</span> {campaign.startDate}</p>}
            {campaign?.deadline && <p><span className="font-bold">End date:</span> {campaign.deadline}</p>}
            {campaign?.industry && <p><span className="font-bold">Industry:</span> {campaign.industry}</p>}
            {campaign?.campaignObjective && <p><span className="font-bold">Campaign objective:</span> {campaign.campaignObjective}</p>}
            {campaign?.collaborationType && <p><span className="font-bold">Collaboration type:</span> {campaign.collaborationType}</p>}
            {campaign?.contentFormat && <p><span className="font-bold">Content format:</span> {campaign.contentFormat}</p>}
            {campaign?.numberOfDeliverables && <p><span className="font-bold">Number of deliverables:</span> {campaign.numberOfDeliverables}</p>}
            {campaign?.listId?.name && <p><span className="font-bold">List:</span> {campaign.listId.name}</p>}
            {campaign?.proposedPayment && <p><span className="font-bold">Proposed payment:</span> {campaign.proposedPayment}</p>}
            {campaign?.paymentTerms && <p><span className="font-bold">Payment terms:</span> {campaign.paymentTerms}</p>}
            {campaign?.contentGuidelines && <p><span className="font-bold">Content guidelines:</span> {campaign.contentGuidelines}</p>}
            {campaign?.additionalNotes && <p><span className="font-bold">Additional notes:</span> {campaign.additionalNotes}</p>}
            {campaign?.subjectLine && <p><span className="font-bold">Subject line:</span> {campaign.subjectLine}</p>}
            {campaign?.paymentMethod.length > 0 && <p><span className="font-bold">Payment method:</span> {campaign.paymentMethod.join(', ')}</p>}
            {campaign?.agencyId?.name && <p><span className="font-bold">Agency:</span> {campaign.agencyId.name}</p>}
            {campaign?.profileId?.name && <p><span className="font-bold">Manager:</span> {campaign.profileId.name}</p>}
            {campaign?.delayFlow && <p><span className="font-bold">Delay flow:</span> {campaign.delayFlow}</p>}
            {campaign?.sendEmailOnDays.length > 0 && <p><span className="font-bold">Send email on days:</span> {campaign.sendEmailOnDays.join(', ')}</p>}
            {campaign?.sendBetweenFrom && campaign?.sendBetweenTo && <p><span className="font-bold">Send between:</span> {campaign.sendBetweenFrom} - {campaign.sendBetweenTo}</p>}
            {campaign?.createdAt && <p><span className="font-bold">Created at:</span> {campaign.createdAt}</p>}
            {campaign?.status && <p><span className="font-bold">Status:</span> {campaign.status}</p>}
          </div>
        </Card>
        <Card>
          <div className="flex flex-col gap-4">
            <p><span className="font-bold">Number of influencers in all campaigns:</span> {data?.influencers || 0}</p>
            <p><span className="font-bold">Number of emails sent:</span> {data?.emailsSent || 0}</p>
            <p><span className="font-bold">Number of replies received:</span> {data?.repliesReceived || 0}</p>
            <p><span className="font-bold">Number of positive responses:</span> {data?.escalated || 0}</p>
          </div>
        </Card>
      </div>
    </>
  )
}

export default CampaignView;
